// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content064_wrapper__D5SNl","container":"Content064_container__tWqqx"};